function dropdown() {
    const mediaQuery = window.matchMedia('(max-width: 767px)');
    const head = document.querySelector('.gh-navigation');
    const menu = head?.querySelector('.gh-navigation-menu');
    const nav = menu?.querySelector('.nav');
    if (!nav) return;
    const logo = head.querySelector('.gh-navigation-logo');
    const navHTML = nav.innerHTML;
    let toggle;
    let popup;

    function setOpen(open, returnFocus = false) {
        if (!toggle || !popup) return;
        head.classList.toggle('is-dropdown-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        popup.hidden = !open;
        if (returnFocus) toggle.focus();
    }
    function makeDropdown() {
        head.classList.remove('is-dropdown-open');
        nav.innerHTML = navHTML;
        toggle = popup = null;
        if (mediaQuery.matches) {
            nav.querySelectorAll('li').forEach((item, index) => { item.style.transitionDelay = `${0.03 * (index + 1)}s`; });
            head.classList.add('is-dropdown-loaded');
            return;
        }
        const items = [];
        while (nav.offsetWidth + 64 > menu.offsetWidth && nav.lastElementChild) {
            items.unshift(nav.lastElementChild);
            nav.lastElementChild.remove();
        }
        if (items.length) {
            const holder = document.createElement('li');
            holder.className = 'gh-more-item';
            toggle = document.createElement('button');
            toggle.type = 'button';
            toggle.className = 'gh-more-toggle gh-icon-button';
            toggle.setAttribute('aria-label', 'More');
            toggle.setAttribute('aria-controls', 'gh-more-links');
            toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor" aria-hidden="true"><circle cx="8" cy="16" r="2.667"/><circle cx="16" cy="16" r="2.667"/><circle cx="24" cy="16" r="2.667"/></svg>';
            popup = document.createElement('ul');
            popup.className = 'gh-dropdown';
            popup.id = 'gh-more-links';
            items.forEach(item => popup.appendChild(item));
            head.classList.toggle('is-dropdown-mega', items.length >= 10);
            if (items.length >= 10) popup.style.gridTemplateRows = `repeat(${Math.ceil(items.length / 2)}, 1fr)`;
            holder.append(toggle, popup);
            nav.appendChild(holder);
            if (toggle.getBoundingClientRect().left < window.innerWidth / 2) popup.classList.add('is-left');
            setOpen(false);
        }
        head.classList.add('is-dropdown-loaded');
    }
    nav.addEventListener('click', event => {
        if (toggle?.contains(event.target)) setOpen(toggle.getAttribute('aria-expanded') !== 'true');
        else if (popup?.contains(event.target)) setOpen(false);
    });
    head.addEventListener('keydown', event => {
        if (event.key === 'Escape' && toggle?.getAttribute('aria-expanded') === 'true') {
            event.stopPropagation();
            setOpen(false, true);
        }
    });
    window.addEventListener('click', event => { if (!event.target.closest('.gh-more-item')) setOpen(false); });
    head.addEventListener('focusout', event => { if (!head.contains(event.relatedTarget)) setOpen(false); });
    imagesLoaded(logo, makeDropdown);
    window.addEventListener('load', makeDropdown);
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(makeDropdown, 1);
    });
}
